import { AppBar, Dialog, Toolbar } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { Loading, PageActionButton, RelodeTheme, Text } from "../";
import { TimesIcon } from "../../";

export const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            appBar: {
                position: "relative",
            },
            titleWrapper: {
                display: "flex",
                overflow: "hidden",
                alignItems: "center",
            },
            title: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                paddingRight: theme.spacing(1),
            },
            toolbar: {
                height: theme.relode.sizes.mobileHeaderHeight,
            },
            content: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                maxHeight: "100%",
                [theme.breakpoints.up("md")]: {
                    flexDirection: "row",
                },
            },
            paper: {
                overflowY: "hidden",
            },
            loading: {
                height: `calc(100% - ${theme.relode.sizes.mobileHeaderHeight}px)`,
            },
            rightContent: {
                marginRight: theme.spacing(2),
            },
        }),
    { name: "FullScreenDialog", classNamePrefix: "relode", index: 20 }
);

type FullScreenDialogCSSProperties =
    | "appBar"
    | "titleWrapper"
    | "title"
    | "content"
    | "paper";
export type FullScreenDialogStyles = Partial<
    Record<FullScreenDialogCSSProperties, string>
>;

interface FullScreenDialogProps {
    children?: React.ReactNode;
    title?: React.ReactNode | string;
    rightContent?: React.ReactNode;
    onClose?: () => void;
    leftActions?: React.ReactNode;
    open: boolean;
    classes?: FullScreenDialogStyles;
    isBusy?: boolean;
}

const CloseButton = (props: { onClick: () => void }) => (
    <PageActionButton
        id="dialogCloseButton"
        onClick={props.onClick}
        title="cancel"
        color="primary"
    >
        <TimesIcon />
    </PageActionButton>
);

export const FullScreenDialog = (props: FullScreenDialogProps) => {
    const classes = useStyles({});
    const contentClasses = classnames(
        classes.content,
        !!props.classes ? props.classes.content : ""
    );
    return props.open ? (
        <Dialog
            fullScreen
            open
            scroll="paper"
            classes={{
                paper: classes.paper,
            }}
        >
            <AppBar className={classes.appBar} color="inherit">
                <Toolbar className={classes.toolbar}>
                    <div className={classes.titleWrapper}>
                        {props.leftActions ? props.leftActions : null}
                        {typeof props.title === "string" ? (
                            <Text
                                id="dialogTitle"
                                variant="h1"
                                color="primary"
                                className={classes.title}
                            >
                                {props.title}
                            </Text>
                        ) : (
                            props.title
                        )}
                    </div>
                    <div style={{ flexGrow: 1 }} />
                    {props.rightContent ? (
                        <span className={classes.rightContent}>
                            {props.rightContent}
                        </span>
                    ) : null}
                    {props.onClose ? (
                        <CloseButton onClick={props.onClose} />
                    ) : null}
                </Toolbar>
            </AppBar>
            <Loading
                isLoading={props.isBusy}
                variant="blur"
                showIndicator={true}
                fillSpace
                classes={{
                    fillSpace: classes.loading,
                }}
            >
                <div className={contentClasses}>{props.children}</div>
            </Loading>
        </Dialog>
    ) : null;
};
